'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Sanitizer = require('acq-components/lib/base-components/Sanitizer/Sanitizer');

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _HeroBanner = require('acq-components/lib/composite-components/HeroBanner/HeroBanner');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _Link = require('acq-components/lib/base-components/Link/Link');

var _componentHelpers = require('../../utils/component-helpers');

var _heroBanner = require('../../redux/selectors/heroBanner');

var selectors = _interopRequireWildcard(_heroBanner);

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardDetailsHeroBannerCorporate = function CardDetailsHeroBannerCorporate(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      dtmHelper = _ref.dtmHelper,
      namespace = _ref.namespace,
      shouldIncludeTnCLinks = _ref.shouldIncludeTnCLinks,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'dtmHelper', 'namespace', 'shouldIncludeTnCLinks']);

  if (!props.hasHeroBannerData) return null;

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: true,
      isImageRepeated: true,
      backgroundImgUrl: props.background.url,
      custClassName: 'hero-banner'
    },
    _react2.default.createElement(_HeroBanner.HeroBanner, {
      styles: styles.hero,
      primaryContentProps: {
        src: props.cardImage.url,
        alt: props.cardImage.alt,
        className: (0, _lodash2.default)(styles, 'hero.image')
      },
      secondaryContentProps: {
        buttonContainerClassname: (0, _lodash2.default)(styles, 'hero.buttonsContainer'),
        titleComponents: {
          headerText: props.cardTitle
        },
        titleComponentsStyles: {
          headerText: (0, _lodash2.default)(styles, 'hero.headerText')
        },
        textComponents: {
          descriptionText: props.description || (0, _componentHelpers.concactDescStr)(props.cardDesc),
          annualFee: props.heroAnnualFeeLabel,
          suppAnnualFee: props.heroSuppAnnualFeeLabel
        },
        textComponentStyles: {
          descriptionText: (0, _lodash2.default)(styles, 'hero.descriptionText'),
          annualFee: (0, _lodash2.default)(styles, 'hero.annualFee'),
          suppAnnualFee: (0, _lodash2.default)(styles, 'hero.suppAnnualFee')
        },
        primaryButtonProps: props.primaryButton && {
          children: props.primaryButton.title,
          className: (0, _classnames2.default)((0, _lodash2.default)(styles, 'hero.link'), 'hero-btn'),
          Component: 'a',
          title: props.primaryButton.hoverText,
          href: dtmHelper.getUrlByLinkObj(props.primaryButton, _dtmConsts.DTM_CONSTS.hero),
          onClick: function onClick() {
            return (0, _dtmEvent.triggerDTMEvent)(dtmHelper.getDtmClickEventObj(_dtmConsts.DTM_CONSTS.actionSpeakToSpecialist, _dtmConsts.DTM_CONSTS.top));
          }
        },
        secondaryButtonProps: props.secondaryButton && {
          children: props.secondaryButton.title,
          className: (0, _lodash2.default)(styles, 'hero.link'),
          title: props.secondaryButton.hoverText,
          onClick: (0, _componentHelpers.getCompareButtonOnClickHandler)({
            dtmHelper: dtmHelper,
            cardShortName: props.cardShortName,
            compareLink: props.secondaryButton,
            section: _dtmConsts.DTM_CONSTS.top
          })
        },
        otherCTAs: props.languageToggleButton && {
          className: styles.hero.languageToggle,
          children: _react2.default.createElement(
            _Link.Link,
            {
              to: dtmHelper && dtmHelper.getUrlByLinkObj((0, _lodash2.default)(props, 'languageToggleButton'), _dtmConsts.DTM_CONSTS.hero),
              className: styles.hero.languageToggleButton,
              namespace: namespace,
              qeId: 'Hero-languageToggle',
              title: props.languageToggleButton.hoverText
            },
            props.languageToggleButton && props.languageToggleButton.title
          )
        },
        footer: {
          children: _react2.default.createElement(
            'div',
            null,
            props.phoneNumberLink && _react2.default.createElement(_Sanitizer.Sanitizer, {
              safelySetInnerHTML: (0, _componentHelpers.concatPhone)(props.phoneNumberLink),
              Component: 'div',
              href: dtmHelper.getUrlByLinkObj((0, _lodash2.default)(props, 'phoneNumberLink.url'), _dtmConsts.DTM_CONSTS.hero),
              target: '_blank',
              className: (0, _lodash2.default)(styles, 'hero.secondarySectionFooter')
            }),
            shouldIncludeTnCLinks && _react2.default.createElement(
              'p',
              { className: (0, _lodash2.default)(styles, 'hero.tncLink') },
              _react2.default.createElement(_Sanitizer.Sanitizer, {
                safelySetInnerHTML: (0, _lodash2.default)(props, 'termAndConditionsLink.title'),
                Component: 'a',
                href: dtmHelper.getUrlByLinkObj((0, _lodash2.default)(props, 'termAndConditionsLink'), _dtmConsts.DTM_CONSTS.hero),
                target: '_blank'
              })
            )
          )
        }
      },
      namespace: namespace
    })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasHeroBannerData: selectors.getHasHeroBannerData(state),
    cardImage: selectors.getCardImage(state),
    background: selectors.getBackground(state),
    cardTypeLabel: selectors.getCardTypeLabel(state),
    cardType: selectors.getCardType(state),
    heroAnnualFeeLabel: selectors.getCorpHeroAnnualFeeLabel(state),
    heroSuppAnnualFeeLabel: selectors.getCorpHeroSubAnnualFeeLabel(state),
    cardTitle: selectors.getCardTitle(state),
    cardDesc: selectors.getCardDesc(state),
    description: selectors.getDescription(state),
    cardShortName: selectors.getCardShortName(state),
    primaryButton: selectors.getPrimaryButton(state),
    secondaryButton: selectors.getSecondaryButton(state),
    termAndConditionsLink: selectors.getTermAndConditionsLink(state),
    phoneNumberLink: selectors.getPhoneNumberLink(state),
    languageToggleButton: selectors.getToggleButton(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CardDetailsHeroBannerCorporate);